module.exports = __webpack_public_path__ + "static/media/water1.ce878ff8.jpg";